/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Frontrow_Point_1Inputs */

const en_frontrow_point_1 = /** @type {(inputs: Frontrow_Point_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A showroom visit booked from the invitation`)
};

/**
* | output |
* | --- |
* | "A showroom visit booked from the invitation" |
*
* @param {Frontrow_Point_1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const frontrow_point_1 = /** @type {((inputs?: Frontrow_Point_1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Frontrow_Point_1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_frontrow_point_1(inputs)
});